module.exports = __webpack_public_path__ + "img/Rubans_pour_mariage.6d236f2.jpg";